import { getProjectsPreviewListAPI, addToProjectFromFavoriteAPI } from '@requests/services/services'

export const unionProjectsList = {
  namespaced: true,
  state: {
    projects: [],
  },
  getters: {
    getProjectsList: state => state.projects,
    getActiveProjectsList: state => state.projects.filter(({ status }) => 0 === status || 1 === status),
  },
  actions: {
    projectListRequest({ commit }) {
      console.log('getProjectsPreviewListAPI get')
      return getProjectsPreviewListAPI.execute().then(({ data: { items } }) => {
        console.log('getProjectsPreviewListAPI', items)
        commit('setUnionList', items)
      })
    },
    async addTalentProject(state, payload) {
      await addToProjectFromFavoriteAPI.execute({}, payload)
    },
  },
  mutations: {
    // eslint-disable-next-line
    setUnionList: (state, response) => state.projects = response,
    addNewList: (state, response) => state.projects.push(response),
  },
}
